import { IApiClient } from "@common/network/interfaces";
import { ApiClient } from "@network/client";
import { fetchForm, fetchTemplate } from "../apis/urls";
import { getConfig } from "@config/index";
import { IFetchTemplatesActionPayload } from "@common/redux/templates/interface";

const ENDPOINTS = {
  fetchTemplates: () => fetchForm,
};
class TemplateRepository {
  private apiClient: IApiClient;
  constructor(apiClient: IApiClient) {
    this.apiClient = apiClient;
  }
  public fetchTemplates = async (data: IFetchTemplatesActionPayload) => {
    const params = data;
    const result = await this.apiClient.get(
      ENDPOINTS.fetchTemplates(),
      params,
      {
        baseURL: getConfig().APP_BE_BASE_URL,
      }
    );
    return result.data;
  };
}
const templateRepository = new TemplateRepository(ApiClient);
export { templateRepository as TemplateRepository };
